import React, {useEffect, useRef, useState} from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {URL_FOR_RESOURCES} from "../../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {CreateAccount} from "./CreateAccountTypes"
import {
  GetCurrentLocale,
  SelectInterface, FormatDateForUrl,
  scrollToId
} from "../../../components/Utils";
import {RootState} from "../../../app/RootReducer";
import useScript from 'react-script-hook';
import CartPage from "../../Cart/CartPage";
import Checkout from "../../Cart/Checkout";
import AccountForm from "./AccountForm";
import {CartDto} from "../../Entity/Cart";
import {submitCart} from "../../Cart/CartSlice";
import {LocalParams} from "../../../components/LocalParams";
import {customerType} from "../../Entity/User";
import { ProductService } from "../../Entity/Product";
import {renderTextArea} from "../../../components/Forms/FormsComponent";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import {customerRegister, getUserAccount, updatePerson} from "../UsersSlice";

interface ComponentProps {
  isCreateAccount: boolean,
  isEditForm: boolean,
  isCartPage: boolean,
  setActiveStep?: any
  activeStep: number,
  remarkText: string|null,
  setRemarqueText: React.Dispatch<React.SetStateAction<string>> | undefined
  selectedServices: SelectInterface | null
  setSelectedServices: React.Dispatch<React.SetStateAction<SelectInterface | null>> | undefined
}

const MultiStepsForm: React.FC<ComponentProps> = ({
                                      isCreateAccount,
                                      isEditForm,
                                      setActiveStep,
                                      activeStep,
                                      isCartPage,
                                      remarkText,
                                      setRemarqueText,
                                      selectedServices,
                                      setSelectedServices
                                    }:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  let isCreatedAccountSuccess = useSelector((state:RootState) => state.userRdc.isRequestSuccess)
  const isRequestSuccessUpdate = useSelector((state:RootState) => state.userRdc.isRequestSuccessUpdate)
  const isCartSubmitSuccess = useSelector((state:RootState) => state.cartRdc.isSubmitSuccess)
  const userAccount = useSelector((state: RootState) => state.userRdc.userDetail?.customer);
  const userAddresses = useSelector((state: RootState) => state.userRdc.userAddresses)

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const [formBirthDate, setFormBirthDate] = useState<Date|null>(null);

  const [selectedCountry, setSelectedCountry] = useState<SelectInterface|null>(null);
  const currentLocale = GetCurrentLocale();
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const isSubmitCartRequesting = useSelector(((state:RootState) => state.cartRdc.isRequestingSubmitCart))

  //form
  const { register, handleSubmit, watch, formState: { errors, isDirty, isValid }, getValues } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUnregister: true,
    criteriaMode: "all",
  });

  const password = useRef({});
  password.current = watch("password", "");

  const [message, setMessage] = useState('');

  useScript({
    src:
      URL_FOR_RESOURCES +'/themes/custom/esm/js/main.js',
    // onload: () => console.log('Script loaded!'),
  });

  let notAuthentificatedInCart = isCartPage && !isAuthenticated

  const userAccountLastName = userAccount && userAccount.lastName;
  const userAccountFirstName = userAccount && userAccount.firstName;
  const userAccountEmail = userAccount && userAccount.email;
  const userAccountPhoneNumber = userAccount && userAccount.phoneNumber;
  const userAddressStreet = userAddresses?.[0]?.street || "";
  const userAddressZip = userAddresses && userAddresses?.[0]?.postcode;
  const userAddressCity = userAddresses && userAddresses?.[0]?.city;
  const userAccountNatRegNum = userAccount && userAccount.nationalRegistrationNumber;
  const userAccountJobDepartment = userAccount && userAccount.jobDepartment;
  const userAccountFax = userAccount && userAccount.fax;
  const userAccountJobFunction = userAccount && userAccount.jobFunction;
  const userAccountCompanyName = userAccount && userAccount.companyName;
  const useraccountTaxNumber = userAccount && userAccount.taxNumber;
  const userAccountSubscribedNewsletter = userAccount && userAccount.subscribedToNewsletter;
  const tokenCart = LocalParams.getItem('tokenCart') as string

  const onSubmit = handleSubmit(({
                                   firstName,
                                   lastName,
                                   email,
                                   password,
                                   subscribedToNewsletter,
                                   nationalRegistrationNumber,
                                   street,
                                   zip,
                                   city,
                                   countryCode,
                                   companyName,
                                   taxNumber,
                                   fax,
                                   jobFunction,
                                   jobDepartment,
                                   phoneNumber,
                                   hasAcceptedConditions,
                                 }) => {
    if(email){
       let newAccount: CreateAccount = {
        firstName,
        lastName,
        email,
        password,
        subscribedToNewsletter,
        nationalRegistrationNumber,
        street,
        zip,
        city,
        countryCode: selectedCountry ? selectedCountry.value : "BE",
        companyName,
        taxNumber,
        fax,
        jobFunction,
        jobDepartment,
        phoneNumber,
        customerType: customerType.COMPANY,
        hasAcceptedConditions: true,
        birthday: formBirthDate ? FormatDateForUrl(formBirthDate) : null,
        language: locale ?? "fr"
      };

      if(!isCartPage){
        if(isEditForm){
          console.log(newAccount)
          try {
            dispatch(updatePerson(newAccount));
            dispatch(getUserAccount(false, false));
          } catch (error) {
            const errorMessage = typeof error === 'string' ? error : 'Une erreur s\'est produite';
            dispatch({ type: 'SET_ERROR_MESSAGE', payload: errorMessage });
          }
        }else{
          dispatch(customerRegister(newAccount));
          setActiveStep(activeStep + 1)
          scrollToId("topPage")
        }
      }
    }
  })

  const [selectedAddressId, setSelectedAddressId] = useState<number | null>(null);
  const submitCartHandle = handleSubmit(({
                                           firstName,
                                           lastName,
                                           email,
                                           phoneNumber,
                                           companyName,
                                           items,
                                           notes,
                                           service,
                                           remark
                                         }) => {
    if (itemsInCart && selectedAddressId !== null) {
        const newCartData: CartDto = {
          email: email || userAccountEmail,
          items: itemsInCart.items,
          notes: notes,
          countryCode: selectedCountry ? selectedCountry.value : "BE",
          service: selectedServices?.value || null,
          remark: remarkText || "",
          billingAddressId : selectedAddressId,
        };
      if (newCartData) {
        scrollToId("topPage");
        dispatch(submitCart(newCartData, tokenCart));
      }
    }
  });

  useEffect(() => {
    if (isCartSubmitSuccess) {
      setActiveStep(activeStep+ 1);
      scrollToId("topPage");
      const timeout = setTimeout(() => {
        window.location.href = "/" + locale + '/' + t('url_catalogue');
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [isCartSubmitSuccess]);


  const [isAlertClosed, setIsAlertClosed] = useState(false)
  const closeAlert = () => {
    setIsAlertClosed(true)
  }

  const [guestData, setGuestData] = useState({})
  const getGuestData = () => {
    const values = getValues();
    setGuestData(values)
  }

  const requiredField = (field: string) =>
  {
    return field !== null && field !== "";
  }

  const dispatch = useDispatch();

  const [wantsAddService, setWantsAddService] = useState(false)

  const handleChangeService = (changeService: boolean) => {
    if(changeService){
      setWantsAddService(true)
    }else{
      setWantsAddService(false)
    }
  }

  const [servicesArray, setServicesArray]= useState<SelectInterface[]>([])
  //prends tous les services des produits dans le cart pour en faire une dropdown
  useEffect(() => {
    if (itemsInCart !== null && itemsInCart.items?.length > 0) {
      const prevServicesArray = [...servicesArray];
      const existingCodes = new Set(prevServicesArray.map(service => service.value));

      itemsInCart.items.forEach(item => {
        const productServices: ProductService[] = item.product.productServices;

        if (Array.isArray(productServices)) {
          productServices.forEach(service => {
            if (!existingCodes.has(service.code)) {
              prevServicesArray.push({
                label: service.name,
                value: service.code
              });
              existingCodes.add(service.code);
            }
          });
        }
      });

      setServicesArray(prevServicesArray);
    }
  }, [itemsInCart]);

  return (
    <form action="#" id={ isCartPage ? "cart-page" : "create-account"} onSubmit={isCartPage ? submitCartHandle : onSubmit}>
      {
        // Si on est sur le profil
        // On affiche l'alerte quand on updaté les datas
        <>
          {
            isEditForm && isRequestSuccessUpdate && !isAlertClosed ?
              <>
                <div className="alert alert-success my-3">
                  {t('account_updated_successfully')}
                  <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                          onClick={() => closeAlert()}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </>

              : null
          }
        </>
      }
      {
        // Pour la page panier, on affiche les infos du panier sur la 1er étape
        isCartPage && activeStep === 0 ?
          <CartPage setActiveStep={setActiveStep} activeStep={activeStep}/>
          : null
      }
      {
        // affiche le formulaire de création de compte à l'étape 0 sur la création de compte
        // ou sur le profil
        // ou sur l'étape 0 du cart si on n'est pas connecté
        notAuthentificatedInCart && activeStep === 0 || isEditForm || isCreateAccount && activeStep === 0 ?
          <div className={isCartPage ? "page slide-page-datas card p-5" : "page slide-page-datas"}>
            <div className="row">
              <AccountForm
                register={register}
                isEditForm={isEditForm}
                notAuthentificatedInCart={notAuthentificatedInCart}
                errors={errors}
                userAccount={userAccount}
                requiredField={requiredField}
                password={password}
                userAccountLastName={userAccountLastName}
                userAccountFirstName={userAccountFirstName}
                userAccountEmail={userAccountEmail}
                userAccountPhoneNumber={userAccountPhoneNumber}
                userAddressStreet={userAddressStreet}
                userAddressZip={userAddressZip}
                userAddressCity={userAddressCity}
                userAccountNatRegNum={userAccountNatRegNum}
                userAccountJobDepartment={userAccountJobDepartment}
                userAccountFax={userAccountFax}
                userAccountJobFunction={userAccountJobFunction}
                userAccountCompanyName={userAccountCompanyName}
                useraccountTaxNumber={useraccountTaxNumber}
                userAccountSubscribedNewsletter={userAccountSubscribedNewsletter}
                currentLocale={currentLocale}
                setSelectedCountry={setSelectedCountry}
                userAddresses={userAddresses}
                selectedCountry={selectedCountry}
              />
              {
                //Si on est dans le profil, on affiche le bouton pour updater les datas
                isEditForm ?
                  <div className="col-md-6 col-sm-12 mb-3">
                    <label className="hidden-visible">{t('save')}</label>
                    <button className="btn btn-primary width100"
                            onClick={() => setIsAlertClosed(false)}>{t('save')}</button>
                  </div>
                  : null
              }
            </div>
            {
              // bouton previous / next dans la création de compte / panier
              !isEditForm ?
                <div className="mb-0 field btns float-end">
                  {
                    !isCreateAccount ?
                      <button className="btn btn-primary mr-5"
                              onClick={() => [setActiveStep(activeStep - 1), scrollToId("topPage")]}>{t('previous')}</button>
                      : null
                  }
                  {
                    isCreateAccount && activeStep === 0 ?
                      <button className="btn btn-primary" disabled={!isDirty || !isValid}
                              type="submit">{t('confirme')}</button>
                      :
                      <button className="btn btn-primary" disabled={!isDirty || !isValid}
                              onClick={() => [setActiveStep(activeStep + 1), getGuestData(), scrollToId("topPage")]}>{t('next')}</button>
                  }
                </div>
                :
                null
            }
          </div>
          :
          // affiche le résumé de la commande sur l'étape 1 du cart
          // ou l'étape 2 en étant connecté
          isCartPage && activeStep === 2 || notAuthentificatedInCart && activeStep === 2 ?
            <>
              {
                isSubmitCartRequesting ?
                  <>
                    <div className="d-flex justify-content-center">
                      <SpinnerOnTop/>
                    </div>
                    <p className="lead pt-3 mb-0 text-center">{t('submit_order_in_progress')}</p>
                  </>
                  :
                  <>
                    <Checkout userAccount={userAccount} guestData={guestData} activeStep={activeStep}
                              selectedCountry={selectedCountry} setRemarqueText={setRemarqueText} selectedAddressId={selectedAddressId} setSelectedAddressId={setSelectedAddressId}/>

                    {/*<article className="row card mb-4 g-0">
                <div className="content-body">
                  <h5 className="card-title">{ t('add_service_to_order') }</h5>
                  <div className="col-md-12">
                  <div className="row g-0">
                    <div className="col-lg-6 mb-3">
                      <div className="box box-check box-inline-form">
                        <label className="form-check">
                          <input className="form-check-input" type="radio" name="addService" onClick={(e) => handleChangeService(true)}/>
                          <b className="border-oncheck"></b>
                          <span className="form-check-label"> {t('yes')}</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="box box-check box-inline-form">
                        <label className="form-check">
                          <input className="form-check-input" type="radio" name="addService" checked={wantsAddService === false} onClick={(e) => handleChangeService(false)}/>
                          <b className="border-oncheck"></b>
                          <span className="form-check-label"> {t('no')}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  </div>
                  {
                    wantsAddService ?
                      <div className="row">
                        <div className="mb-4">
                          <div className="form-group select2Part select2multiple w-100 floating-group">
                            {
                              renderSelect(locale, t('select_service'), "service", setSelectedServices, false, servicesArray, selectedServices)
                            }
                          </div>
                        </div>
                        <div className="mb-4">
                          {
                            renderTextArea(t('add_remark'), "remark", false, setRemarqueText)
                          }
                        </div>
                      </div>
                      :
                      null
                  }
                </div>
              </article>*/}

                    <div className="mb-0 field btns float-end">
                      <button
                        className="btn btn-primary mr-5"
                        onClick={() => {
                          const newStep = activeStep === 2 ? 0 : activeStep - 1;
                          setActiveStep(newStep);
                          scrollToId("topPage");
                        }}
                      >
                        {t('previous')}
                      </button>
                      <button className="btn btn-primary" type="submit" disabled={!isValid}>{t('confirme')}</button>
                    </div>
                  </>
              }
            </>
            : null
      }
      {
        //étape succès si on est à l'étape 1 sur la création de compte
        // ou sur le cart à l'étape 3 en étant connecté
        // ou sur le cart à l'étape 4 en étant déconnecté
        activeStep === 1 && isCreateAccount || activeStep === 3 && !notAuthentificatedInCart || activeStep === 4 && notAuthentificatedInCart ?
          <div className="page slide-page-success">
            <div className="row text-center">
              {
                isCreatedAccountSuccess || isCartSubmitSuccess ?
                  <div className="col-md-12">
                    {
                      // si c'est succès et qu'on n'est pas sur le profil
                      !isEditForm && !isCartPage ?
                        <>
                          <svg width="96px" height="96px" viewBox="0 0 96 96" version="1.1"
                               xmlns="http://www.w3.org/2000/svg">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="round-check">
                                <circle id="Oval" fill="#6aada369" cx="48" cy="48" r="48"/>
                                <circle id="Oval-Copy" fill="#6aada3" cx="48" cy="48" r="36"/>
                                <polyline id="Line" stroke="#FFF" strokeWidth="4" strokeLinecap="round"
                                          points="34.188562 49.6867496 44 59.3734993 63.1968462 40.3594229"/>
                              </g>
                            </g>
                          </svg>
                          <div className="my-3">
                            <h4>{t('profile_created_successfully')}</h4>
                            <p>
                              {t('profile_created_confirmation_email')}
                            </p>
                          </div>
                        </>
                        :
                        null
                    }
                  </div>
                  : null
              }
              {
                // si c'est succès et qu'on est sur le cart
                isCartPage ?
                  <div className="col-md-12">
                    <svg width="96px" height="96px" viewBox="0 0 96 96" version="1.1"
                         xmlns="http://www.w3.org/2000/svg">
                      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="round-check">
                          <circle id="Oval" fill="#6aada369" cx="48" cy="48" r="48"></circle>
                          <circle id="Oval-Copy" fill="#6aada3" cx="48" cy="48" r="36"></circle>
                          <polyline id="Line" stroke="#FFF" strokeWidth="4" strokeLinecap="round"
                                    points="34.188562 49.6867496 44 59.3734993 63.1968462 40.3594229"></polyline>
                        </g>
                      </g>
                    </svg>
                    <div className="my-3">
                      <h4>{t('ordered_successfully')}</h4>
                      <p>
                        {t('order_email_send')}
                      </p>
                    </div>
                  </div>
                  : null
              }
            </div>
          </div>
          :
          null
      }
    </form>
  )
}

export default MultiStepsForm;
